import { useWindow } from './useWindow';
const useNavigate = () => {
    const myWindow = useWindow();
    const navigate = (url) => {
        if (url && myWindow) {
            var pattern = /^https?:\/\//i;
            if (pattern.test(url)) {
                myWindow.location.href = url;
            }
            const slashCharacter = url.startsWith('/') ? '' : '/';
            myWindow.location.href = `${myWindow.location.origin}${slashCharacter}${url}`;
        }
    };
    return { navigate };
};
export default useNavigate;
